import wxOpenButton from './wxOpenButton.vue';
import { isBaiduMap } from '../utils';
export default {
  data() {
    return {
      isBaiduMap: isBaiduMap(),
      showbutton: true
    };
  },
  computed: {},
  components: {
    wxOpenButton
  },
  props: {
    jumpWxAppUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    // 不显示点击取百度查看
    closeShowbutton() {
      this.showbutton = false;
    },
    // 跳转到地图
    jumpToMap() {
      this.$emit('open-Baidu-Map');
    }
  }
};